export enum Direction {
  LTR = 'ltr',
  RTL = 'rtl',
}
